import { required, min, max } from '@unitedtraders/validators';
import { Instrument } from '../../hooks/mapInstruments';
import { useBalance } from '../../hooks/useBalance';
import { inBalance } from '../../utils/validators';

// t('validator:minimum')
// t('validator:maximum')

export const useAmountValidators = ({ currency, minimum, maximum }: Instrument) => {
  const { balance } = useBalance(currency);

  return [
    required(),
    min(minimum.value, 'validator:minimum', { minimum }),
    max(maximum.value, 'validator:maximum', { maximum }),
    inBalance(balance),
  ];
};
